import className from 'classnames/bind';
import { motion } from 'motion/react';
import { MaterialLoader } from '@components';

import styles from './Loader.module.scss';
import { forwardRef, useEffect, useState } from 'react';
import { updateBodyScroll } from '@/core/utils';
const cx = className.bind(styles);

const Loader = forwardRef<HTMLDivElement, { isPreview: boolean }>(({ isPreview }, ref) => {
  const [showSpinner, setShowSpinner] = useState(false);
  useEffect(() => {
    updateBodyScroll(true);
    const timeout = setTimeout(() => { setShowSpinner(true); }, 550);
    return () => {
      clearTimeout(timeout);
      updateBodyScroll(false);
    }
  }, []);
  return (
    <div className={cx(["loader"])} ref={ref}>
      <div className={cx(["content"])}>
        <MaterialLoader
          className={cx(["loader__loader"])}
          initial={{ opacity: 0 }}
          animate={showSpinner ? { opacity: 1 } : { opacity: 0 }}
        />
        {isPreview && <div className={cx(["preview-text", "text-l"])}>Loading Preview...</div>}
      </div>
    </div>
  )
});

export default motion.create(Loader);